import { TZDate } from '@date-fns/tz';
import { format, formatISO } from 'date-fns';

interface IntervalTimestampParts {
    date: string;
    time: string;
    offset: string;
    offsetMinutes: number;
    timestamp: string;
}

export function getIntervalTimestampParts(
    timestamp: number,
    timeZone: string
): IntervalTimestampParts {
    // Truncate the instant before converting zones; resetting local seconds can
    // select the first occurrence of a repeated hour instead of the saved one.
    const minuteTimestamp = Math.floor(timestamp / 60_000) * 60_000;
    const zonedDate = new TZDate(minuteTimestamp, timeZone);
    const date = format(zonedDate, 'yyyy-MM-dd');
    const time = format(zonedDate, 'HH:mm');
    return {
        date,
        time,
        offset: format(zonedDate, 'O'),
        offsetMinutes: -zonedDate.getTimezoneOffset(),
        timestamp: formatISO(zonedDate),
    };
}
